import { defineComponent as p, computed as t, openBlock as C, createBlock as u, resolveDynamicComponent as f, normalizeClass as a, withCtx as v, createElementVNode as r, renderSlot as d } from "vue";
import { _ as y } from "./chunks/_plugin-vue_export-helper.CHgC5LLL.js";
import './assets/BaseCard.css';const g = /* @__PURE__ */ p({
  __name: "BaseCard",
  props: {
    type: { default: "" },
    rootComponent: { default: "div" },
    cardImgClasses: { default: "" },
    cardBodyClasses: { default: "" }
  },
  emits: ["click"],
  setup(c, { emit: l }) {
    const n = l, s = c, i = t(
      () => s.type === "news" ? "news-card" : s.type
    ), m = t(() => s.type ? `${s.type}-img` : "");
    return (e, o) => (C(), u(f(e.rootComponent), {
      class: a(["card", [i.value]]),
      onClick: o[0] || (o[0] = (B) => n("click"))
    }, {
      default: v(() => [
        r("div", {
          class: a(["card-img", [m.value, e.cardImgClasses]])
        }, [
          d(e.$slots, "card-image", {}, void 0, !0)
        ], 2),
        r("div", {
          class: a(["card-body", [e.cardBodyClasses]])
        }, [
          d(e.$slots, "card-description", {}, void 0, !0)
        ], 2)
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), I = /* @__PURE__ */ y(g, [["__scopeId", "data-v-245e50e1"]]);
export {
  I as default
};
